<mat-card [class.tax-message-card]="isTaxMessage">
  <div class="d-flex">
    <img *ngIf="isTaxMessage" alt="ic_warning" aria-hidden="true" src="/assets/images/ic-tax.svg" />
    <mat-icon *ngIf="!isTaxMessage">
      {{ type }}
    </mat-icon>
    <div id="text-ellipsis" [class.collapsed]="!isExpanded" class="text-format mat-body-2">
      <span [innerHTML]="resultText"></span> &nbsp;
      <ng-content select="[content]"></ng-content>
    </div>
    <mat-icon tabindex="0" class="toggle-icon" (click)="toggleEllipsis()">{{
      isExpanded ? 'expand_less' : 'expand_more'
    }}</mat-icon>
  </div>
</mat-card>
